<template>
  <div class="home">
    <router-link to="/game" class="homeItem" id="game"></router-link>
    <router-link to="/illust" class="homeItem" id="illust"></router-link>
    <router-link to="/music" class="homeItem" id="music"></router-link>
    <router-link to="/novel" class="homeItem" id="novel"></router-link>
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home{background-image: url('../assets/background.png');}
/*スマートフォン向け 600px未満*/
.home{
  display: block;
  position: fixed;
}

.homeItem{
  width: 40vw;
  height: 40vw;
  position: absolute;
  display:block;
  background-repeat: no-repeat;
  background-position: 50% 100%;
  background-size: 100% auto;
}

#illust{
  top: calc(calc(100vh - 80px) / 7);
  right: 20px;
  background-image: url("../assets/gura.png");
}

#music{
  top: calc(calc(100vh - 80px) / 1.75);
  left: 20px;
  background-image: url("../assets/ongaku.png");
}

#novel{
  top: calc(calc(100vh - 80px) / 1.75);
  right: 20px;
  background-image: url("../assets/syousetu.png");
}

#game{
  top: calc(calc(100vh - 80px) / 7);
  left: 20px;
  background-image: url("../assets/ge-mu.png");
}

@media screen and (orientation: landscape) and (min-width: 600px){
  .homeItem{
    width: 30vh;
    height: 30vh;
  }

  #illust{
  right: calc(30% - calc(1920 * calc(calc(100vw / 1920) * 0.1)));
}

#music{
  left: calc(30% - calc(1920 * calc(calc(100vw / 1920) * 0.1)));
}

#novel{
  right: calc(30% - calc(1920 * calc(calc(100vw / 1920) * 0.1)));
}

#game{
  left: calc(30% - calc(1920 * calc(calc(100vw / 1920) * 0.1)));
}
}

/*PC向け 1280px以上*/
@media screen and (min-width:1280px){
.home{
  display: block;
  position: fixed;
}

.homeItem{
  width: calc(100vw / 6);
  height: calc(100vw / 6);
  position: absolute;
  display:block;
  background-repeat: no-repeat;
  background-position: 50% 100%;
  background-size: 100% auto;
}

#illust{
  top: calc(calc(100vh - 80px) / 8);
  right: calc(50% - calc(1920 * calc(calc(100vw / 1920) * 0.1)));
  transform: translateX(50%);
  -webkit-transform: translateX(50%);
  -ms-transform: translateX(50%);
  background-image: url("../assets/gura.png");
}

#music{
  /*top: calc(calc(100vh - 80px) / 1.75);*/
  top: auto;
  bottom: calc(calc(100vh - 80px) / 9.5);
  left: calc(50% - calc(1920 * calc(calc(100vw / 1920) * 0.1)));
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  background-image: url("../assets/ongaku.png");
}

#novel{
  /*top: calc(calc(100vh - 80px) / 1.75);*/
  top: auto;
  bottom: calc(calc(100vh - 80px) / 9.5);
  right: calc(50% - calc(1920 * calc(calc(100vw / 1920) * 0.1)));
  transform: translateX(50%);
  -webkit-transform: translateX(50%);
  -ms-transform: translateX(50%);
  background-image: url("../assets/syousetu.png");
}

#game{
  top: calc(calc(100vh - 80px) / 8);
  left: calc(50% - calc(1920 * calc(calc(100vw / 1920) * 0.1)));
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  background-image: url("../assets/ge-mu.png");
}
}
</style>
